import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { SignUp } from '../Api/SignUp';
import { SignIn } from '../Api/SignIn';
import { LoginPagePBody, LoginPagePHtml } from '../css/LoginPageP';
import { Helmet } from 'react-helmet';
import { ResetPassword } from "../Api/ResetPassword";

export default function LoginP() {

    const [ischecked, setIsChecked] = useState(true);
    const [showResetPassword, setShowResetPassword] = useState(false);

    const [resetPasswordData, setResetPasswordData] = useState({
        username: "",
        password: "",
        confirmPassword: ""
    });
    const { setLoad, setLoadColor } = useContext(Context);
    const navigate = useNavigate();

    useEffect(() => {
        const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;
        if (auth_token) {
            navigate('/game');
        }
    }, [navigate]); // ✅ FIXED: added navigate as dependency

    const [signUpIn, setSignUpIn] = useState(false);
    const [signUpData, setSignUpData] = useState({
        name: "",
        username: "",
        password: "",
        phone: "",
    });
    const [signInData, setSignInData] = useState({
        username: "",
        password: "",
    });

    const handleChangeSignUp = (e, value) => {
        setSignUpData(prev => ({
            ...prev,
            [value === 'mobile' ? 'phone' : value]: e.target.value,
        }));
    };

    const handleChangeSignIn = (e, value) => {
        setSignInData(prev => ({
            ...prev,
            [value]: e.target.value,
        }));
    };

    const handleResetPassword = async () => {

        if (
            resetPasswordData.username === "" ||
            resetPasswordData.password === "" ||
            resetPasswordData.confirmPassword === ""
        ) {
            toast.error("Please fill all fields.");
            return;
        }

        if (
            resetPasswordData.password !==
            resetPasswordData.confirmPassword
        ) {
            toast.error("Passwords do not match.");
            return;
        }

        setLoad(true);
        setLoadColor("#ff4364");

        const res = await ResetPassword({
            username: resetPasswordData.username,
            password: resetPasswordData.password
        });

        setLoad(false);

        if (res?.data?.status) {

            toast.success("Password reset successfully.");

            setShowResetPassword(false);

            setResetPasswordData({
                username: "",
                password: "",
                confirmPassword: ""
            });

        } else {

            toast.error(res?.data?.message);

        }
    };

    const handleResetPasswordChange = (e, field) => {
        setResetPasswordData(prev => ({
            ...prev,
            [field]: e.target.value
        }));
    };

    const handleClickSignUpUser = async (e) => {
        e.preventDefault();
        const { name, username, password, phone } = signUpData;

        if (name && username && password && phone.length === 10) {
            setLoad(true);
            setLoadColor("#ff4364");

            let res = await SignUp(signUpData);
            if (res) {
                if (res.data.status) {
                    localStorage.setItem("userinfo", JSON.stringify(res.data.data));
                    navigate("/game");
                    toast.success('User Registered Successfully', { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
                    setSignUpData({ name: "", username: "", password: "", phone: "" });
                } else {
                    toast.error(res.data.message, { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
                }
            }

            setLoad(false);
        } else if (phone.length !== 10) {
            toast.warn('Give Correct Number', { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
        } else {
            toast.error("Give all Details Properly", { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
        }
    };

    const handleClickSignInUser = async (e) => {
        e.preventDefault();
        const { username, password } = signInData;

        if (username && password) {
            setLoad(true);
            setLoadColor("#ff4364");

            let res = await SignIn(signInData);
            if (res) {
                if (res.data.status) {
                    localStorage.setItem("userinfo", JSON.stringify(res.data.data));
                    toast.success('User Login Successfully', { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
                    navigate("/game");
                    setSignInData({ username: "", password: "" });
                } else {
                    toast.error(res.data.message, { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
                }
            }

            setLoad(false);
        } else {
            toast.error("Give all Details Properly", { position: "top-right", autoClose: 1500, theme: "colored", transition: Flip });
        }
    };

    const handleChangeLoginMethod = () => {
        setSignUpIn(!signUpIn);
        setIsChecked(prev => !prev);
        setSignInData({ username: "", password: "" });
        setSignUpData({ name: "", username: "", password: "", phone: "" });
    };

    return (
        <>
            <LoginPagePHtml>
                <LoginPagePHtml>
                    <Helmet>
                        {/* Page Title */}
                        <title>Login Page | Access Jantri APK in Portrait View</title>

                        {/* SEO Description */}
                        <meta
                            name="description"
                            content="This page allows users to log in to the Jantri APK with optimized portrait view for mobile devices."
                        />

                        {/* SEO Directives */}
                        <meta name="robots" content="noindex, nofollow" />

                        {/* Author */}
                        <meta name="author" content="Matka Jantri Team (Miraj Sports)" />

                        {/* Canonical URL */}
                        <link rel="canonical" href="https://app.matkajantri.com/login" />

                        {/* Favicon and icons */}
                        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                        {/* Mobile Optimization */}
                        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                        {/* Open Graph */}
                        <meta property="og:title" content="Login Page | Access Jantri APK in Portrait View" />
                        <meta
                            property="og:description"
                            content="This page allows users to log in to the Jantri APK with optimized portrait view for mobile devices."
                        />
                        <meta property="og:type" content="website" />
                        <meta property="og:url" content="https://app.matkajantri.com" />
                        <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                        <meta name="google-site-verification" content="d6d81656210c6db7" />
                    </Helmet>
                </LoginPagePHtml>


                <LoginPagePBody>
                    <div className="wrapperP">
                        <div className="title-text">
                            <div className="title login">Matka Jantri</div>
                            {/* <div className="title signup">Signup Form</div> */}
                        </div>
                        <div className="form-containerP">
                            <div className="slide-controls">
                                <input type="radio" name="slide" id="login" onClick={handleChangeLoginMethod} checked={ischecked} />
                                <input type="radio" name="slide" id="signup" onClick={handleChangeLoginMethod} checked={!ischecked} />
                                <label htmlFor="login" className="slide login">Login</label>
                                <label htmlFor="signup" className="slide signup">Signup</label>
                                <div className="slider-tab"></div>
                            </div>
                            <div className="form-inner">
                                {/* Login Form */}
                                <form action="#" className="login" style={{ marginLeft: !ischecked ? "-50%" : "0%" }}>
                                    <div className="field">
                                        <input type="text" placeholder="Username" value={signInData.username} onChange={(e) => handleChangeSignIn(e, "username")} required />
                                    </div>
                                    <div className="field">
                                        <input type="password" placeholder="Password" value={signInData.password} onChange={(e) => handleChangeSignIn(e, "password")} required />
                                    </div>
                                    <div className="pass-link">
                                        <button
                                            type="button"
                                            className="link-button"
                                            onClick={() => setShowResetPassword(true)}
                                        >
                                            Forgot Password?
                                        </button>
                                    </div>
                                    <div className="field btn1">
                                        <div className="btn-layer"></div>
                                        <input type="submit" value="Login" onClick={handleClickSignInUser} />
                                    </div>
                                    <div className="signup-link">
                                        Not a member? <button type="button" onClick={handleChangeLoginMethod} className="link-button">Signup now</button>
                                    </div>
                                </form>

                                {/* Signup Form */}
                                <form action="#" className="signup">
                                    <div className="field">
                                        <input type="text" placeholder="Name" value={signUpData.name} onChange={(e) => handleChangeSignUp(e, "name")} required />
                                    </div>
                                    <div className="field">
                                        <input type="text" placeholder="Username" value={signUpData.username} onChange={(e) => handleChangeSignUp(e, "username")} required />
                                    </div>
                                    <div className="field">
                                        <input type="password" placeholder="Password" value={signUpData.password} onChange={(e) => handleChangeSignUp(e, "password")} required />
                                    </div>
                                    <div className="field">
                                        <input
                                            type="tel"
                                            placeholder="Mobile No."
                                            value={signUpData.phone}
                                            onChange={(e) => {
                                                if ((e.target.value === '' || /^\d+$/.test(e.target.value)) && e.target.value.length <= 10) {
                                                    handleChangeSignUp(e, "mobile");
                                                }
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="field btn1">
                                        <div className="btn-layer"></div>
                                        <input type="submit" value="Signup" onClick={handleClickSignUpUser} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </LoginPagePBody>

                {showResetPassword && (
                    <div className="reset-password-overlay">
                        <div className="reset-password-modal">

                            <div className="reset-header">
                                <h2>Reset Password</h2>

                                <button
                                    className="close-btn"
                                    onClick={() => {
                                        setShowResetPassword(false);

                                        setResetPasswordData({
                                            username: "",
                                            password: "",
                                            confirmPassword: ""
                                        });
                                    }}
                                >
                                    ✕
                                </button>
                            </div>

                            <p className="reset-subtitle">
                                Enter your username and choose a new password.
                                Password reset will only work from a previously used network.
                            </p>

                            <input
                                type="text"
                                placeholder="Username"
                                value={resetPasswordData.username}
                                onChange={(e) =>
                                    handleResetPasswordChange(e, "username")
                                }
                            />

                            <input
                                type="password"
                                placeholder="New Password"
                                value={resetPasswordData.password}
                                onChange={(e) =>
                                    handleResetPasswordChange(e, "password")
                                }
                            />

                            <input
                                type="password"
                                placeholder="Confirm Password"
                                value={resetPasswordData.confirmPassword}
                                onChange={(e) =>
                                    handleResetPasswordChange(e, "confirmPassword")
                                }
                            />

                            <button
                                type="button"
                                className="reset-btn"
                                onClick={handleResetPassword}
                            >
                                Reset Password
                            </button>

                        </div>
                    </div>
                )}

            </LoginPagePHtml>
        </>
    );
}
